import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { mergeMap, tap } from "rxjs/operators";
import { ConfigService } from "../../../config/config.service";
import { Client } from "../../shared/client/client";
import { ClientService } from "../../shared/client/client.service";

@Injectable({
  providedIn: 'root'
})
export class LectureCabService {

  lecture;

  constructor(
    private configService: ConfigService,
    private http: HttpClient,
    private clientService: ClientService
  ) { }

  checkLecture(lectureForm: any): Observable<any> {
    return this.clientService.getFirstCurrentClient().pipe(
      mergeMap(client => {
        return this.configService.getConfig().pipe(
          mergeMap(config => {
            return this.http.post(
              config.apiPoint + config.getClientLectureCheck.replace('{client}', client.id), lectureForm
            )
          }));
      }));
  }

  getHistorique(client: Client, data: any): Observable<any> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.post<Observable<any>>(
          config.apiPoint + config.getClientLectureHistorique.replace('{client}', client.id), data
        );
      }));
  }

  getBilan(client: Client, data: any): Observable<any> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.post<Observable<any>>(
          config.apiPoint + config.getClientLectureBilan.replace('{client}', client.id), data
        );
      }));
  }

  exportLecture(form: any) {
    return this.clientService.getFirstCurrentClient().pipe(
      mergeMap(client => {
        return this.configService.getConfig().pipe(
          mergeMap(config => {
            return this.http.post(
              config.apiPoint + config.getClientLectureHistoriqueExport.replace('{client}', client.id), form, { responseType: 'arraybuffer' }
            ).pipe(
              tap(res => {
                let blob = new Blob([res], { type: 'application/vnd.ms-excel' });
                const nav = (window.navigator as any);
                if (nav.msSaveOrOpenBlob) {
                  let newUrl = nav.msSaveOrOpenBlob(blob, `historiqueLectures.xlsx`);
                } else {
                  let link = document.createElement('a');
                  link.href = window.URL.createObjectURL(blob);
                  link.setAttribute('download', `historiqueLectures.xlsx`);
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }
              }));
          }));
      }));
  }

  exportBilan(form: any) {
    return this.clientService.getFirstCurrentClient().pipe(
      mergeMap(client => {
        return this.configService.getConfig().pipe(
          mergeMap(config => {
            return this.http.post(
              config.apiPoint + config.getClientLectureBilanExport.replace('{client}', client.id), form, { responseType: 'arraybuffer' }
            ).pipe(
              tap(res => {
                let blob = new Blob([res], { type: 'application/vnd.ms-excel' });
                const nav = (window.navigator as any);
                if (nav.msSaveOrOpenBlob) {
                  let newUrl = nav.msSaveOrOpenBlob(blob, `bilanLectures.xlsx`);
                } else {
                  let link = document.createElement('a');
                  link.href = window.URL.createObjectURL(blob);
                  link.setAttribute('download', `bilanLectures.xlsx`);
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }
              }));
          }));
      }));
  }

  getLectureCabEtapes() {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Observable<any>>(
          config.apiPoint + config.getLectureCabEtapes
        );
      }));
  }
}
